import { LayerDefinition } from './types';

export const sunIntensityDefinition: LayerDefinition = {
  id: 'sun_intensity',
  name: 'Solar Intensity',
  category: 'core_met',
  categoryLabel: 'Core Meteorological',
  icon: '☀️',
  description: 'Direct surface downwelling solar irradiance (W/m²) from numerical weather prediction model radiative transfer schemes.',
  sourceModels: ['rrfs', 'rdps', 'gfs', 'gdps', 'icon13'],
  outputModels: ['Solar Intensity .pmtiles per model'],
  config: {
    defaultModel: 'rrfs'
  }
};

export default sunIntensityDefinition;
